import { useAuth } from "@/contexts/AuthContext";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/atoms/card";
import { User, Package } from "lucide-react";

export default function DriverPortal() {
  const { user, supabaseInfo } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Welcome Section */}
        <div className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            ¡Bienvenido, {user?.name?.split(" ")[0]}!
          </h2>
          <p className="text-gray-600">
            Aquí puedes ver tu perfil junto a tu información como conductor.
          </p>
        </div>

        {/* Driver Info Card */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center">
                <User className="h-5 w-5 mr-2" />
                Información Personal
              </CardTitle>
              <CardDescription>
                Tu información básica de conductor
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div>
                <label className="text-sm font-medium text-gray-500">
                  Nombre
                </label>
                <p className="text-gray-900">{user?.name}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-500">
                  Email
                </label>
                <p className="text-gray-900">{user?.email}</p>
              </div>
              {supabaseInfo?.phone && (
                <div>
                  <label className="text-sm font-medium text-gray-500">
                    Teléfono
                  </label>
                  <p className="text-gray-900">{supabaseInfo.phone}</p>
                </div>
              )}
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center">
                <Package className="h-5 w-5 mr-2" />
                Estado del Conductor
              </CardTitle>
              <CardDescription>
                Tu estado actual en la plataforma
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div>
                <label className="text-sm font-medium text-gray-500">
                  Estado
                </label>
                <div className="flex items-center">
                  <div
                    className={`h-2 w-2 ${
                      supabaseInfo?.status === "active"
                        ? "bg-green-400"
                        : "bg-red-400"
                    } rounded-full mr-2`}
                  ></div>
                  <p className="text-gray-900">
                    {supabaseInfo?.status === "active" ? "Activo" : "Inactivo"}
                  </p>
                </div>
              </div>
              {supabaseInfo?.vehicle_type && (
                <div>
                  <label className="text-sm font-medium text-gray-500">
                    Tipo de Vehículo
                  </label>
                  <p className="text-gray-900">
                    {supabaseInfo.vehicle_type?.toLowerCase() === "car"
                      ? "Automóvil"
                      : supabaseInfo.vehicle_type?.toLowerCase() === "moto" ||
                          supabaseInfo.vehicle_type?.toLowerCase() ===
                            "motorcycle"
                        ? "Motocicleta"
                        : "Bicicleta"}
                  </p>
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      </main>
    </div>
  );
}
